import { BLOCKS, INLINES } from '@contentful/rich-text-types';

const embeddedEntry = (node, key, h) => h('RouterLink', { key, class: 'link', props: { to: { name: node.data.target.sys.contentType.sys.id } } }, node.content[0].value);

const hyperLink = (node, key, h, next) => h(
  'a',
  {
    key,
    class: 'link',
    attrs: {
      href: node.data.uri,
    },
  },
  next(node.content, key, h, next),
);

const paragraph = (node, key, h, next) => {
  // Handle line breaks
  if (node.content.length === 1 && node.content[0].value === '') {
    Object.assign(node.content[0], { value: '\n' });
  }

  return h('p', { key, class: 'whitespace-pre-wrap' }, next(node.content, key, h, next));
};

const h1 = (node, key, h, next) => (
  h('h1', { key, class: 'text-2xl' }, next(node.content, key, h, next))
);

const h6 = (node, key, h, next) => (
  h('h6', { key, class: 'text-lg' }, next(node.content, key, h, next))
);

export default {
  [INLINES.ENTRY_HYPERLINK]: embeddedEntry,
  [INLINES.HYPERLINK]: hyperLink,
  [BLOCKS.PARAGRAPH]: paragraph,
  [BLOCKS.HEADING_6]: h6,
  [BLOCKS.HEADING_1]: h1,
};
